/**
 * Best-effort haptic feedback. Mirrors the native `HapticFeedback.*` calls on
 * confirm/complete actions. Uses the Vibration API where available (Android
 * Chrome); silently no-ops on iOS Safari, which doesn't expose it.
 */
function vibrate(pattern: number | number[]): void {
  try {
    if (typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function') {
      navigator.vibrate(pattern);
    }
  } catch {
    /* ignore */
  }
}

export const haptics = {
  light: () => vibrate(10),
  medium: () => vibrate(25),
  heavy: () => vibrate([30, 20, 30]),
};
